import * as React from 'react';

import Text from 'crehana-ui/Text';
import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';

const Tag: React.FC<Partial<CourseCardProps>> = props => {
  const { isOrganization, courseTag } = props;

  if (!isOrganization && courseTag) {
    return (
      <div
        className="TagComponent flex items-center"
        css={`
          position: absolute;
          z-index: 2;
          left: 12px;
          top: 12px;
          padding: 4px 9px;
          background-color: ${courseTag.backgroundColor || '#06f'};
        `}
      >
        {courseTag.icon && (
          <img
            src={courseTag.icon}
            alt={courseTag.textLabel as string}
            style={{
              width: 'auto',
              height: 15,
            }}
            className="mr-4"
          />
        )}
        <Text style={{ color: courseTag.textColor || '' }} type="caption">
          {courseTag.textLabel}
        </Text>
      </div>
    );
  }
  return null;
};

export default Tag;
